var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"unauthorized"},[_c('div',{staticClass:"description"},[_vm._v("使用前微信要求您的授权，请点击下方使用完整服务后继续。。。")])])}]

export { render, staticRenderFns }